import * as React from 'react';
import { SVGProps } from 'react';

const IconWatchStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path d="M5 2h1v3.749l2.79 1.954-.573.82L5 6.268V2Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0Zm-1 0A5 5 0 1 1 1 6a5 5 0 0 1 10 0Z"
    />
  </svg>
);
export default IconWatchStrokedSizeXs;
